// extracted by mini-css-extract-plugin
export var copyright = "index-module--copyright--EZzcS";
export var copyrightWrapper = "index-module--copyright-wrapper--NMqJX";
export var footerAndSnsLinkGroupWrapper = "index-module--footer-and-sns-link-group-wrapper--0Q85M";
export var footerLinkGroupWrapper = "index-module--footer-link-group-wrapper--DAFCt";
export var root = "index-module--root--eL-kZ";
export var snsLinkGroupWrapper = "index-module--sns-link-group-wrapper--IRDvn";